import Vue from 'vue';
import Router from 'vue-router';

import Doucment from './components/document.vue';
import Account from './components/account.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: {name: 'document'}
    },
    {
      name: 'document',
      path: '/document',
      component: Doucment
    },
    {
      name: 'account',
      path: '/account',
      component: Account
    }
  ]
});

export default router;